import { Button } from 'antd'
import { useRouter } from 'next/navigation'
import Image from 'next/image'

export const PhysiciansBanner = () => {
  const router = useRouter()

  return (
    <div
      className='bg-[#f2eee4] my-0 rounded-2xl -mx-6'
      data-testid='physicians-banner-container'
    >
      <div className='container px-4 py-8 lg:py-12 mx-auto '>
        <div className='grid md:grid-cols-2 gap-8 items-center rounded-2xl'>
          <div className='space-y-6 md:space-y-0 flex flex-col items-center text-center md:order-2'>
            {/* Text */}
            <h1 className='text-3xl lg:text-5xl text-[#202020] font-light  md:mb-8'>
              Finally, making it easier to find your{' '}
              <span className='text-[#06686B] font-semibold'>physician</span>.
            </h1>

            {/* Image - shows up only on mobile/tablet */}
            <div className='md:hidden'>
              <Image
                src='/assets/illustrations/physicians-banner.png'
                alt='Illustration of three physicians wearing lab coats and stethoscopes.'
                width={640}
                height={496}
                className='w-full h-auto object-contain'
                priority
              />
            </div>

            {/* Button */}
            <Button
              type='primary'
              className='h-auto'
              style={{ padding: 24, fontSize: 18 }}
              onClick={() => router.push('/search')}
            >
              Find Physician
            </Button>
          </div>

          {/* Image - shows up only on desktop */}
          <div className='hidden md:block md:order-1'>
            <Image
              src='/assets/illustrations/physicians-banner.png'
              alt='Illustration of three physicians wearing lab coats and stethoscopes.'
              width={640}
              height={496}
              className='w-full h-auto object-contain'
              sizes='(max-width: 1024px) 100vw, 50vw'
              priority
            />
          </div>
        </div>
      </div>
    </div>
  )
}
